function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#38b1df;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Asset balance icon");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_layers_2561455",
  "data-name": "iconfinder layers 2561455"
}, React.createElement("g", {
  id: "Path_35",
  "data-name": "Path 35"
}, React.createElement("path", {
  className: "cls-1",
  d: "M12.54,13.9a1,1,0,0,1-.45-.11L.59,8a1,1,0,0,1,0-1.78L12.09.51a1,1,0,0,1,.9,0l11.5,5.75a1,1,0,0,1,0,1.78L13,13.79A1,1,0,0,1,12.54,13.9ZM3.28,7.15l9.26,4.63L21.8,7.15,12.54,2.52Z"
})), React.createElement("g", {
  id: "Path_36",
  "data-name": "Path 36"
}, React.createElement("path", {
  className: "cls-1",
  d: "M12.54,25.4a1,1,0,0,1-.45-.11L.59,19.54a1,1,0,0,1,.9-1.78l11,5.52,11.05-5.52a1,1,0,1,1,.9,1.78L13,25.29A1,1,0,0,1,12.54,25.4Z"
})), React.createElement("g", {
  id: "Path_37",
  "data-name": "Path 37"
}, React.createElement("path", {
  className: "cls-1",
  d: "M12.54,19.65a1,1,0,0,1-.45-.11L.59,13.79A1,1,0,1,1,1.49,12l11,5.52L23.59,12a1,1,0,1,1,.9,1.78L13,19.54A1,1,0,0,1,12.54,19.65Z"
})));

var SvgAssetBalance = function SvgAssetBalance(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 25 26",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAssetBalance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/asset-balance.d5bc3eac.svg";
export { ForwardRef as ReactComponent };